import { useCallback } from 'react'
import { useOutletContext } from 'react-router-dom'

import type { Project } from '@/api/types'
import { useAuthStore } from '@/store/authStore'
import { hasPermission, type PermissionKey } from '../../../packages/shared/src/permissions'

export type { PermissionKey }

/** İzin sorgusu: arayüz rolden değil izinden karar verir. */
export type Can = (key: PermissionKey) => boolean

/** Projedeki izinlerim (`Project.permissions`) için sorgu. */
export function projectCan(project: Pick<Project, 'permissions'> | null | undefined): Can {
  const permissions = project?.permissions
  return (key) => hasPermission(permissions, key)
}

/** Sistem izinlerim (`CurrentUser.permissions`): yönetim ekranları, proje oluşturma. */
export function useSystemCan(): Can {
  const permissions = useAuthStore((s) => s.user?.permissions)
  return useCallback((key: PermissionKey) => hasPermission(permissions, key), [permissions])
}

/** Proje sekmelerinin ortak bağlamı (ProjectLayout'un <Outlet>'i). */
export interface ProjectContext {
  project: Project
  can: Can
}

export function useProject(): ProjectContext {
  return useOutletContext<ProjectContext>()
}
